import React from 'react';
import PropTypes from 'prop-types';
import { HashRouter } from 'react-router-dom';

import { LanguageContext } from '@mssgme/hooks';
import { CardRoutes } from '../CardRoutes';
import { CardContainer } from '../Elements';
import { useLocales, usePreview } from './hooks';

export function CardPreview({ widgetMode = false, ...rest }) {
    const { i18n, isLoaded } = useLocales('card');
    const { preview } = usePreview();

    return isLoaded ? (
        <HashRouter>
            <LanguageContext.Provider value={i18n.language}>
                <CardContainer widgetMode={widgetMode} {...rest}>
                    <CardRoutes
                        data={preview}
                        widgetMode={widgetMode}
                        paths={{ home: '/', collection: '/c/:collectionSlug', product: '/p/:productSlug' }}
                    />
                </CardContainer>
            </LanguageContext.Provider>
        </HashRouter>
    ) : null;
}

CardPreview.propTypes = {
    widgetMode: PropTypes.bool,
};
